import React from 'react'
import PropTypes from 'prop-types'
import {Divider, Flex, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'

const HelpMeChooseHeader = ({headerTitle}) => {
    const styles = useMultiStyleConfig('HelpMeChoose')
    return (
        <Flex {...styles.pageHeaderInnerContainer}>
            <Text {...styles.headerText} data-testid="help-me-choose-header">
                <FormattedMessage id="helpMeChoose.page.header" defaultMessage="Help me choose" />
            </Text>
            <Text {...styles.headerSubText} data-testid="help-me-choose-sub-header">
                <FormattedMessage
                    id="helpMeChoose.page.subHeader"
                    defaultMessage="{headerTitle}"
                    values={{headerTitle}}
                />
            </Text>
            <Divider {...styles.headerDivider} />
        </Flex>
    )
}

HelpMeChooseHeader.propTypes = {headerTitle: PropTypes.string}
export default HelpMeChooseHeader
